import { get_companies } from "../api";
import type { User } from "../api";
import type { Company } from "../api/types";
import { useKeyedRequest } from "./useKeyedRequest";

// Stable, so the option lists memoised on it keep their identity until names arrive.
const NO_COMPANIES: Company[] = [];

/**
 * Names for the people pickers' company headers. Fetched only when `users` span more than one
 * company, the only time a header shows; a failure costs the nicer label (headers fall back to
 * the company id), not an error banner.
 */
export const usePeopleCompanies = (users: User[]) => {
  const spansManyCompanies = new Set(users.map(candidate => candidate.company_id)).size > 1;
  const { data } = useKeyedRequest(spansManyCompanies ? "companies" : null, () =>
    get_companies().then(loaded => loaded.items),
  );
  return data ?? NO_COMPANIES;
};
